import {
  NavLink,
  Route,
  Redirect,
  Switch,
  useRouteMatch,
  useLocation
} from "polyrouter";
import React from "react";
import DeviceUsers from "./Users/DeviceUsers";
import DeviceUserDetailsRouter from "./Users/View/DeviceUserDetails";
import DeviceUserGroupRouter from "./Groups/DeviceUserGroupRouter";
import { Layout } from "views/Main/Layouts";
import { useTranslation } from "utilities/i18n";
import { ProtectedRoute } from "TsRoleGuards";

export const DeviceUsersRouter: React.FC = () => {
  const root = useRouteMatch().path;
  const { Sidebar } = Layout;
  const { t } = useTranslation();
  const { pathname } = useLocation();

  const isGroupDetailsView = pathname.includes("/groups/details");
  const isUserDetailsView = pathname.includes("/users/details");

  let back = undefined;
  if (isGroupDetailsView) {
    back = {
      to: "/manage/device-users/groups",
      title: t("DEVICE_USER_GROUP_other"),
      iconDesc: t("RETURN_TO_DEVICE_USER_GROUPS")
    };
  } else if (isUserDetailsView) {
    back = {
      to: "/manage/device-users",
      title: t("DEVICE_USERS"),
      iconDesc: t("RETURN_TO_DEVICE_USERS")
    };
  }

  return (
    <Layout back={back}>
      {!(isUserDetailsView || isGroupDetailsView) && (
        <div className="fixed">
          <Sidebar staySmall>
            <span className="title-capitalized">{t("DEVICE_USERS")}</span>
            <ul className="menu router">
              <li>
                <NavLink nest to={`/users`}>
                  {t("USERS")}
                </NavLink>
              </li>
              <li>
                <NavLink nest to={`/groups`}>
                  {t("GROUP_other")}
                </NavLink>
              </li>
            </ul>
          </Sidebar>
        </div>
      )}
      <Switch>
        <Route path={`${root}/users/details`}>
          <DeviceUserDetailsRouter />
        </Route>
        <ProtectedRoute path={`${root}/groups`} requirement={"read:usergroup"}>
          <DeviceUserGroupRouter />
        </ProtectedRoute>
        <Route path={`${root}/users`}>
          <DeviceUsers />
        </Route>
        <Redirect to={`${root}/users`} />
      </Switch>
    </Layout>
  );
};

export default DeviceUsersRouter;
